import React, { useState } from 'react';
import { Container, Row, Media, Badge, Table, Nav, NavItem, TabContent, TabPane, NavLink, List } from 'reactstrap';
import SkeletonImage from '../SkeletonImage';
import classnames from 'classnames';
import UnitReviews from './ReviewComponent';
import Dream from './dream/DreamComponent';

const lbIconSize = {
    maxHeight: 32,
    maxWidth: 32
}

function RenderStat({ unitStats }) {
    return (
        <>
            <Row className="gs-unit-block">
                <div className="gs-unit-table-scroll gs-unit-table-scroll--art">
                    <Table bordered className="gs-unit-table">
                        <tbody>
                        <tr>
                            <th>
                                <center>HP</center>
                            </th>
                            <th>
                                <center>ATK</center>
                            </th>
                            <th>
                                <center>DEF</center>
                            </th>
                        </tr>
                        <tr>
                            <td>
                                <div className="gs-unit-stat-value">
                                    <span>{unitStats.hp}</span>
                                    <Badge className="gs-badge gs-badge--info" pill>+{unitStats.hpplus}</Badge>
                                </div>
                            </td>
                            <td>
                                <div className="gs-unit-stat-value">
                                    <span>{unitStats.atk}</span>
                                    <Badge className="gs-badge gs-badge--info" pill>+{unitStats.atkplus}</Badge>
                                </div>
                            </td>
                            <td>
                                <div className="gs-unit-stat-value">
                                    <span>{unitStats.def}</span>
                                    <Badge className="gs-badge gs-badge--info" pill>+{unitStats.defplus}</Badge>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </Table>
                </div>
            </Row>
        </>
    )
}

function RenderSlots({ unitSlots }) {
    return (
        <Row className="gs-unit-block">
            <h3 className="gs-unit-section-title">SLOTS</h3>
            <div className="gs-unit-table-scroll gs-unit-table-scroll--art">
                <Table bordered className="gs-unit-table gs-unit-table--slots">
                    <colgroup>
                        <col />
                        <col />
                        <col />
                    </colgroup>
                    <tbody>
                    <tr>
                        <td>
                            <div className="gs-unit-slot">
                                <span className="gs-unit-slot__stars">{unitSlots.slot1}☆</span>
                                <Media src={unitSlots.slot1type} style={lbIconSize} />
                            </div>
                        </td>
                        <td>
                            <div className="gs-unit-slot">
                                <span className="gs-unit-slot__stars">{unitSlots.slot2}☆</span>
                                <Media src={unitSlots.slot2type} style={lbIconSize} />
                            </div>
                        </td>
                        <td>
                            <div className="gs-unit-slot">
                                <span className="gs-unit-slot__stars">{unitSlots.slot3}☆</span>
                                <span className="gs-unit-slot__icons">
                                    {
                                    unitSlots.slot31type ? <><Media src={unitSlots.slot31type} style={lbIconSize} />&nbsp;/&nbsp;<Media src={unitSlots.slot32type} style={lbIconSize} /></>
                                    : <Media src={unitSlots.slot3type} style={lbIconSize} /> 
                                    }
                                </span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </Table>
            </div>
        </Row>
    )
}

function RenderSkills({ unitSkill, unitReview, isReview }) {
    return (
        <center>
            { unitSkill.skill1break ? 
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">SKILL</h3>
                    <center><p>{unitSkill.skill}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.skillbreak1} BREAK</Badge></p></center>
                    <center><p>{unitSkill.magiaskill}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.skillbreak2} BREAK</Badge></p></center>
                </Row> : 
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">SKILL</h3>
                    <center><p>{unitSkill.skill}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.skillbreak} BREAK</Badge></p></center>
                    {
                        unitReview.skill && isReview && <UnitReviews review={unitReview.skill} /> 
                    }
                </Row>
            }
            
            <Row className="gs-unit-block">
                <h3 className="gs-unit-section-title">ARTS</h3>
                <center><p>{unitSkill.arts}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.artsbreak} BREAK</Badge></p></center>
                {
                    unitReview.arts && isReview && <UnitReviews review={unitReview.arts} /> 
                }
            </Row>

            {
                unitSkill.protagonize &&
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">PROTAGONIZE</h3>
                    <center><p>{unitSkill.protagonize}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.protagonizebreak} BREAK</Badge></p></center>
                </Row>
            }    

            { unitSkill.trueartsbreak || unitSkill.trueartsbreak === 0 ? 
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">TRUE ARTS</h3>
                    <center><p>{unitSkill.truearts}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.trueartsbreak} BREAK</Badge></p></center>
                    {
                    unitReview.truearts && isReview  && <UnitReviews review={unitReview.truearts} /> 
                    }
                </Row>
            : null }

            { unitSkill.trueartsbreak1 &&
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">TRUE ARTS</h3>
                    <center><p>{unitSkill.truearts1}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.trueartsbreak1} BREAK</Badge></p></center>
                    <center><p>{unitSkill.truearts2}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.trueartsbreak2} BREAK</Badge></p></center>
                </Row> 
            }

            { unitSkill.crossarts &&
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">CROSS ARTS</h3>
                    <center><p>{unitSkill.crossarts}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.crossartsbreak} BREAK</Badge></p></center>
                    {
                        unitReview.crossarts && isReview && <UnitReviews review={unitReview.crossarts} />
                    }
                </Row> 
            }

            { unitSkill.superequipname && 
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">Super "{unitSkill.superequipname}"</h3>
                    <h4>5☆ <img src={unitSkill.superequiptype} style={lbIconSize} alt="Super Equipment Slot Type" /></h4>
                    <center><p>{unitSkill.superequip}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.superequipbreak} BREAK</Badge></p></center>
                    {
                        unitReview.superequip && isReview  && <UnitReviews review={unitReview.superequip} /> 
                    }
                    <center>
                        <b>NOTES:</b>
                        <List type="unstyled">
                            <li>The Abilities of the Equip originally in the <img src={unitSkill.superequiptype} style={{maxWidth: "25px"}} alt="Super Equipment Slot Type" /> slot will be retained.</li>
                            <li>The active of the Equip originally in the <img src={unitSkill.superequiptype} style={{maxWidth: "25px"}} alt="Super Equipment Slot Type" /> slot cannot be activated while this Equip replaces it. If it was on cooldown when this Equip replaces it, the cooldown will continue counting down while this Equip is replacing it.</li>
                        </List>
                    </center>
                </Row> 
            }
            {
                unitSkill.superarts && 
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">SUPER ARTS</h3>
                    <center><p>{unitSkill.superarts}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.superartsbreak} BREAK</Badge></p></center>
                    {
                        unitReview.superarts && isReview && <UnitReviews review={unitReview.superarts} />
                    }
                </Row> 
            }

            { unitSkill.phantombullet && 
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">PHANTOM BULLET</h3>
                    <center><p>{unitSkill.phantombullet}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.phantombulletbreak} BREAK</Badge></p></center>
                    {
                        unitReview.phantombullet && isReview  && <UnitReviews review={unitReview.phantombullet} /> 
                    }
                </Row> 
            }
            
            {
                unitSkill.exarts && 
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">EX ARTS</h3>
                    <center><p>{unitSkill.exarts}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.exartsbreak} BREAK</Badge></p></center>
                </Row>
            }

            {
                unitSkill.originbullet && 
                <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">Origin Bullet</h3>
                    <center><p>{unitSkill.originbullet}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.originbulletbreak} BREAK</Badge></p></center>
                </Row>
            }
            
        </center>
    )
}

function RenderPassives({ unitPassive, isReview, unitReview }) {
    return (
        <Row className="gs-unit-block">
            <h3 className="gs-unit-section-title">PASSIVES</h3>
            <List type="unstyled" className="gs-unit-passive-list">
                <li>{unitPassive.ability1}</li>
                {isReview && unitReview.ability1 && <UnitReviews review={unitReview.ability1} />}
                { unitPassive.ability2 && 
                    <>
                        <li>{unitPassive.ability2}</li>
                        {isReview && unitReview.ability2 && <UnitReviews review={unitReview.ability2} />}
                    </> 
                }
                { unitPassive.ability3 && 
                    <>
                        <li>{unitPassive.ability3}</li>
                        {isReview && unitReview.ability3 && <UnitReviews review={unitReview.ability3} />}
                    </> 
                }
                { unitPassive.ability4 && 
                    <>
                        <li>{unitPassive.ability4}</li>
                        {isReview && unitReview.ability4 && <UnitReviews review={unitReview.ability4} />}
                    </> 
                }
                { unitPassive.ability5 && 
                    <>
                        <li>{unitPassive.ability5}</li>
                        {isReview && unitReview.ability5 && <UnitReviews review={unitReview.ability5} />}
                    </> 
                }
                { unitPassive.ability6 && 
                    <>
                        <li>{unitPassive.ability6}</li>
                        {isReview && unitReview.ability6 && <UnitReviews review={unitReview.ability6} />}
                    </> 
                }
                { unitPassive.ability7 && 
                    <>
                        <li>{unitPassive.ability7}</li>
                        {isReview && unitReview.ability7 && <UnitReviews review={unitReview.ability7} />}
                    </> 
                }
            </List>
        </Row>
    )
}

function typeIconSrc(name) {
    if (!name) return null;
    return `/db/Icons/types/${String(name).replace(/\s+/g, '')}_Icon.webp`;
}

function UnitIdentityMeta({ attribute, type }) {
    if (!attribute && !type) return null;

    const attrClass = String(attribute || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');

    return (
        <div
            className="gs-unit-identity"
            aria-label={[attribute, type].filter(Boolean).join(', ')}
        >
            {attribute ? (
                <span className={`gs-unit-identity__chip gs-unit-identity__chip--${attrClass}`}>
                    <img
                        className="gs-unit-identity__icon"
                        src={typeIconSrc(attribute)}
                        alt=""
                        loading="lazy"
                    />
                    <span className="gs-unit-identity__value">{attribute}</span>
                </span>
            ) : null}
            {type ? (
                <span className="gs-unit-identity__chip gs-unit-identity__chip--race">
                    <img
                        className="gs-unit-identity__icon"
                        src={typeIconSrc(type)}
                        alt=""
                        loading="lazy"
                    />
                    <span className="gs-unit-identity__value">{type}</span>
                </span>
            ) : null}
        </div>
    );
}

function RenderImageAndTypes({ unitImage, unitAtt, unitType, unitName }) {
    //Hook for Special Illustration
    const [specialShift, setSpecialShift] = useState('1')

    //Toggle Tab for Illustration
    const spToggle = tab => {
        if(specialShift !== tab) setSpecialShift(tab)
    }
    
    if (unitImage.detailsuper) {
        return (
            <>
            {
                unitImage.thumbspecial
                ?
                <>
                    
                    <TabContent activeTab={specialShift}>
                        <TabPane tabId="1">
                            <RenderDetail detail={unitImage.detailsuper} />
                        </TabPane>
                        <TabPane tabId="2">
                            <RenderDetail detail={unitImage.detailspecial} />
                        </TabPane>
                        {
                            unitImage.thumbspecial2 
                            &&
                            <TabPane tabId="3">
                                <RenderDetail detail={unitImage.detailspecial2} />
                            </TabPane> 
                        }
                    </TabContent>
                    {unitImage.thumbspecial2 ? (
                        <p className="gs-unit-detail__note" style={{marginTop: "2em"}}>This unit has 2 Special Illustrations. <br/>You may toggle between the Super Artwork and the Special Artworks</p>
                    ) : (
                        <p className="gs-unit-detail__note" style={{marginTop: "2em"}}>This unit has a Special Illustration. <br/>You may toggle between the Super Artwork and the Special Artwork</p>
                    )}
                    <Nav pills justified className="gs-tabs gs-tabs--thumbs gs-tabs--compact">
                        <NavItem>
                            <NavLink className={classnames({ active: specialShift === '1' })}
                                onClick={() => {spToggle('1')}} >
                                    <SkeletonImage
                                        src={unitImage.thumbsuper}
                                        alt=""
                                        frameClassName="gs-skeleton-frame--detail-thumb"
                                        loading="lazy"
                                    />
                            </NavLink> 
                        </NavItem>
                        <NavItem>
                            <NavLink className={classnames({ active: specialShift === '2' })}
                                onClick={() => {spToggle('2')}} >
                                    <SkeletonImage
                                        src={unitImage.thumbspecial}
                                        alt=""
                                        frameClassName="gs-skeleton-frame--detail-thumb"
                                        loading="lazy"
                                    />
                            </NavLink>
                        </NavItem>
                        {
                            unitImage.thumbspecial2
                            &&
                            <NavItem>
                                <NavLink className={classnames({ active: specialShift === '3' })}
                                    onClick={() => {spToggle('3')}} >
                                        <SkeletonImage
                                            src={unitImage.thumbspecial2}
                                            alt=""
                                            frameClassName="gs-skeleton-frame--detail-thumb"
                                            loading="lazy"
                                        />
                                </NavLink>
                            </NavItem>
                        }
                    </Nav>
                </>
                :
                <>
                    <RenderDetail detail={unitImage.detailsuper} />
                </>
            }
                <h1 className="gs-unit-detail__name"><strong>{unitName}</strong></h1>
                <UnitIdentityMeta attribute={unitAtt} type={unitType} />
            </>
        )
    }

    if (unitImage.detailawk) {
        return (
            <>
            {
                unitImage.thumbspecial
                ?
                <>
                    
                    <TabContent activeTab={specialShift}>
                        <TabPane tabId="1">
                            <RenderDetail detail={unitImage.detailawk} />
                        </TabPane>
                        <TabPane tabId="2">
                            <RenderDetail detail={unitImage.detailspecial} />
                        </TabPane>
                    </TabContent>
                    <p className="gs-unit-detail__note" style={{marginTop: "2em"}}>This unit has a Special Illustration. <br/>You may toggle between the Awoken Artwork and the Special Artwork</p>
                    <Nav pills justified className="gs-tabs gs-tabs--thumbs gs-tabs--compact">
                    <NavItem>
                        <NavLink className={classnames({ active: specialShift === '1' })}
                            onClick={() => {spToggle('1')}} >
                                <SkeletonImage
                                    src={unitImage.thumbawk}
                                    alt=""
                                    frameClassName="gs-skeleton-frame--detail-thumb"
                                    loading="lazy"
                                />
                        </NavLink> 
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: specialShift === '2' })}
                            onClick={() => {spToggle('2')}} >
                                <SkeletonImage
                                    src={unitImage.thumbspecial}
                                    alt=""
                                    frameClassName="gs-skeleton-frame--detail-thumb"
                                    loading="lazy"
                                />
                        </NavLink>
                    </NavItem>
                    </Nav>
                </>
                :
                <>
                    <RenderDetail detail={unitImage.detailawk} />
                    
                </>
            }
                <h1 className="gs-unit-detail__name"><strong>{unitName}</strong></h1>
                <UnitIdentityMeta attribute={unitAtt} type={unitType} />
            </>
        )
    }

    if (unitImage.detail5) {
        return (
            <>
                <RenderDetail detail={unitImage.detail5} />
                <h1 className="gs-unit-detail__name"><strong>{unitName}</strong></h1>
                <UnitIdentityMeta attribute={unitAtt} type={unitType} />
            </>
        )
    }
}
export function RenderStats({unitName, unitStats, unitStatsJP = false, unitAtt, unitType, unitSkill, 
                            unitSkillJP = false, unitPassive, unitPassiveJP = false, unitSlots, 
                            unitSlotsJP = false, unitImage, unitReview = false, unitDreamJP = false, unitDreamGL = false, unitDream = false})
                            {
    //Hook for Tab State
    const [currentTab, setCurrentTab] = useState('1');
    const [serverTab, setServerTab] = useState('1');

    //Toggle Tab for Revelation
    const toggle = tab => {
        if(currentTab !== tab) setCurrentTab(tab);
    }

    //Toggle Tab for Server
    const serverToggle = tab => {
        if(serverTab !== tab) setServerTab(tab)
    }

    //Review Button Toggle
    const [review, setReview] = useState(false)

    return (
        <Container className="gs-unit-detail gs-unit-stats">
            <center>
                <RenderImageAndTypes unitImage={unitImage} unitName={unitName} unitAtt={unitAtt} unitType={unitType} />
            </center>
            { 
                unitSkill.revelation 
                ? 
                <center>
                    <Nav pills justified className="gs-tabs gs-tabs--thumbs gs-tabs--compact">
                    <NavItem>
                        <NavLink className={classnames({ active: currentTab === '1' })}
                            onClick={() => {toggle('1')}} >
                                <SkeletonImage
                                    src={unitImage.thumbawk}
                                    alt=""
                                    frameClassName="gs-skeleton-frame--detail-thumb"
                                    loading="lazy"
                                />
                        </NavLink> 
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: currentTab === '2' })}
                            onClick={() => {toggle('2')}} >
                                <SkeletonImage
                                    src={unitImage.revelation}
                                    alt=""
                                    frameClassName="gs-skeleton-frame--detail-thumb"
                                    loading="lazy"
                                />
                        </NavLink>
                    </NavItem>
                    </Nav>
                    <TabContent activeTab={currentTab}>
                        <TabPane tabId="1">
                                <RenderStat unitStats={unitStats} />
                                <RenderSlots unitSlots={unitSlots} />
                                {unitReview &&
                                    <button type="button" className="gs-btn gs-btn--ghost gs-unit-review-toggle" onClick={() => setReview(!review)}>
                                        { review ?  <>Hide Review</>  : <>Show Review</>}
                                    
                                    </button> 
                                }
                                <RenderSkills unitSkill={unitSkill} unitReview={unitReview} isReview={review}/>
                                <RenderPassives unitPassive={unitPassive} unitReview={unitReview} isReview={review}/>
                                {
                                    review ? 
                                    <>
                                        <h3 className="gs-unit-section-title">SUMMARY</h3>
                                        <UnitReviews review={unitReview.overall} />
                                        <center><i className="gs-unit-detail__meta">Review Last Updated {unitReview.lastupdated}</i></center>
                                    </> 
                                    : null
                                }
                        </TabPane>
                        <TabPane tabId="2">
                            <RenderStat unitStats={unitStats} />
                            <RenderSlots unitSlots={unitSlots} />
                            {unitReview &&
                                    <button type="button" className="gs-btn gs-btn--ghost gs-unit-review-toggle" onClick={() => setReview(!review)}>
                                        { review ?  <>Hide Review</>  : <>Show Review</>}
                                    
                                    </button> 
                            }

                            <RevelationMode unitSkill={unitSkill.revelation} unitReview={unitReview.revelation} isReview={review}/>
                            <RenderPassives unitPassive={unitPassive} unitReview={unitReview} isReview={review}/>
                            {
                                    review ? 
                                    <>
                                        <h3 className="gs-unit-section-title">SUMMARY</h3>
                                        <UnitReviews review={unitReview.overall} />
                                        <center><i className="gs-unit-detail__meta">Review Last Updated {unitReview.lastupdated}</i></center>
                                    </> 
                                    : null
                            }
                        </TabPane>
                    </TabContent>
                </center> 
            :
                <center>
                    { 
                        unitStatsJP || unitSkillJP || unitSlotsJP || unitPassiveJP || unitDreamJP ? 
                            <>
                                <p className="gs-unit-detail__note"><i><b>This unit has different stats for each server. Please select the server you want to view the stats for.</b></i></p>
                                
                                <Nav pills justified className="gs-tabs gs-tabs--compact">
                                    <NavItem>
                                        <NavLink className={classnames({ active: serverTab === '1' })}
                                            onClick={() => {serverToggle('1')}} >
                                                <span style={{userSelect: "none"}} >Global</span>
                                        </NavLink> 
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={classnames({ active: serverTab === '2' })}
                                            onClick={() => {serverToggle('2')}} >
                                                <span style={{userSelect: "none"}} >Japan</span>
                                        </NavLink> 
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={serverTab}>
                                    <TabPane tabId="1">
                                        <RenderStat unitStats={unitStats} />
                                        <RenderSlots unitSlots={unitSlots} />
                                        {unitReview &&
                                            <button type="button" className="gs-btn gs-btn--ghost gs-unit-review-toggle" onClick={() => setReview(!review)}>
                                                { review ?  <>Hide Review</>  : <>Show Review</>}
                                            
                                            </button> 
                                        }
                                        <RenderSkills unitSkill={unitSkill} unitReview={unitReview} isReview={review}/>
                                        <RenderPassives unitPassive={unitPassive} unitReview={unitReview} isReview={review}/>
                                        {
                                            (unitDreamGL || unitDream) && <Dream dream={unitDreamGL ? unitDreamGL : unitDream} />
                                        }
                                        {
                                            review ? 
                                            <>
                                                <h3 className="gs-unit-section-title">SUMMARY</h3>
                                                <UnitReviews review={unitReview.overall} />
                                                <center><i className="gs-unit-detail__meta">Review Last Updated {unitReview.lastupdated}</i></center>
                                            </> 
                                            : null
                                        }
                                    </TabPane>
                                    <TabPane tabId="2">
                                        {
                                            unitStatsJP ? <RenderStat unitStats={unitStatsJP} /> : <RenderStat unitStats={unitStats} />
                                        }
                                        {
                                            unitSlotsJP ? <RenderSlots unitSlots={unitSlotsJP} /> : <RenderSlots unitSlots={unitSlots} />
                                        }
                                        {unitReview &&
                                            <button type="button" className="gs-btn gs-btn--ghost gs-unit-review-toggle" onClick={() => setReview(!review)}>
                                                { review ?  <>Hide Review</>  : <>Show Review</>}
                                            
                                            </button> 
                                        }
                                        {
                                            unitSkillJP ? <RenderSkills unitSkill={unitSkillJP} unitReview={unitReview} isReview={review} /> : <RenderSkills unitSkill={unitSkill} unitReview={unitReview} isReview={review} />
                                        }
                                        {
                                            unitPassiveJP ? <RenderPassives unitPassive={unitPassiveJP} unitReview={unitReview} isReview={review} /> : <RenderPassives unitPassive={unitPassive} unitReview={unitReview} isReview={review}/>
                                        }
                                        {
                                            (unitDreamJP || unitDream) && <Dream dream={unitDreamJP ? unitDreamJP : unitDream} />
                                        }
                                        {
                                            review ? 
                                            <>
                                                <h3 className="gs-unit-section-title">SUMMARY</h3>
                                                <UnitReviews review={unitReview.overall} />
                                                <center><i className="gs-unit-detail__meta">Review Last Updated {unitReview.lastupdated}</i></center>
                                            </> 
                                            : null
                                        }
                                    </TabPane>
                                </TabContent>
                            </>
                        :
                            <>
                                <RenderStat unitStats={unitStats} />
                                <RenderSlots unitSlots={unitSlots} />
                                {unitReview &&
                                    <button type="button" className="gs-btn gs-btn--ghost gs-unit-review-toggle" onClick={() => setReview(!review)}>
                                        { review ?  <>Hide Review</>  : <>Show Review</>}
                                    
                                    </button> 
                                }
                                <RenderSkills unitSkill={unitSkill} unitReview={unitReview} isReview={review}/>
                                <RenderPassives unitPassive={unitPassive} unitReview={unitReview} isReview={review}/>
                                {
                                    unitDream && <Dream dream={unitDream} />
                                }
                                {
                                    review ? 
                                    <>
                                        <h3 className="gs-unit-section-title">SUMMARY</h3>
                                        <UnitReviews review={unitReview.overall} />
                                        <center><i className="gs-unit-detail__meta">Review Last Updated {unitReview.lastupdated}</i></center>
                                    </> 
                                    : null
                                }
                            </>
                    }
                </center>
            }
            
            
        </Container>

    );
}

//Revelation Skill Tab
export function RevelationMode ({unitSkill, unitReview, isReview}) {
    return (
        <>
            
            <Row className="gs-unit-block">
                    <h3 className="gs-unit-section-title">REVELATION SKILLS</h3>
                    <List className="gs-unit-passive-list">
                        <center><li>{unitSkill.skill1}&nbsp;<Badge className="gs-badge gs-badge--accent" pill>{unitSkill.skill1break} BREAK</Badge></li></center>
                            {
                                unitReview.skill1 && isReview && <UnitReviews review={unitReview.skill1} /> 
                            }

                        <center><li>{unitSkill.skill2}&nbsp;<Badge className="gs-badge gs-badge--accent" pill>{unitSkill.skill2break} BREAK</Badge></li></center>
                            {
                                unitReview.skill2 && isReview && <UnitReviews review={unitReview.skill2} /> 
                            }

                        <center><li>{unitSkill.skill3}&nbsp;<Badge className="gs-badge gs-badge--accent" pill>{unitSkill.skill3break} BREAK</Badge></li></center>
                            {
                                unitReview.skill3 && isReview && <UnitReviews review={unitReview.skill3} /> 
                            }
                    </List>
                    <h3 className="gs-unit-section-title">MEGA SKILL</h3>
                    <center><p>{unitSkill.megaskill}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.megaskillbreak} BREAK</Badge></p></center>
                    {
                        unitReview.megaskill && isReview && <UnitReviews review={unitReview.megaskill} /> 
                    }
            </Row>
            <Row className="gs-unit-block">
                <h3 className="gs-unit-section-title">MEGA ARTS</h3>
                <center><p>{unitSkill.megaarts}<br/><Badge className="gs-badge gs-badge--accent" pill>{unitSkill.megaartsbreak}BREAK</Badge></p></center>
                {
                        unitReview.megaarts && isReview && <UnitReviews review={unitReview.megaarts} /> 
                }
            </Row>
        </>
    )
}

function RenderDetail({detail}){
    //Shows the Unit Detail
    return(
        <div className="gs-unit-detail-art">
            <SkeletonImage
                src={detail}
                alt=""
                className="gs-unit-detail-art__img"
                frameClassName="gs-skeleton-frame--detail"
                loading="lazy"
            />
        </div>
    )
}
